<template>
  <div class="ndsMarkdownViewer">
    <Viewer
      ref="markdownViewer"
      :initial-value="value"
      :options="viewerOptions"
    />
  </div>
</template>

<script setup lang="ts">
import { Viewer } from '@toast-ui/vue-editor'
import type { ViewerOptions, Sanitizer } from '@toast-ui/editor'
import { ref, watch } from 'vue'
import '@toast-ui/editor/dist/i18n/fr-fr'

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
  sanitize: {
    type: Boolean,
    default: true,
  },
})

const disableSanitizer: Sanitizer = (content: string) => content

const viewerOptions: Partial<ViewerOptions> = {
  usageStatistics: false,
  customHTMLSanitizer: props.sanitize ? void 0 : disableSanitizer,
}

const markdownViewer = ref<InstanceType<typeof Viewer> | null>(null)

watch(
  () => props.value,
  (newValue) => {
    markdownViewer.value?.invoke('setMarkdown', newValue)
  }
)
</script>

<style lang="postcss" scoped>
.ndsMarkdownViewer {
  width: 100%;

  &::v-deep .toastui-editor-contents {
    font-size: 14px;
    font-family: inherit;

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-style: normal;
      font-weight: 700;
      margin: 0;
      -webkit-font-smoothing: antialiased;
    }

    h1 {
      font-size: 40px;
      line-height: 52px;
    }
    h2 {
      font-size: 36px;
      line-height: 44px;
    }
    h3 {
      font-size: 32px;
      line-height: 40px;
    }
    h4 {
      font-size: 28px;
      line-height: 36px;
    }
    h5 {
      font-size: 24px;
      line-height: 32px;
    }
    h6 {
      font-size: 20px;
      line-height: 28px;
    }

    a {
      cursor: pointer;
    }
  }
}
</style>
